<template>
  <div class="LevelSear" style="margin-left:10px;">
      <div class="levelField" style="border-radius: 10px 10px 10px 10px;
      box-shadow: 1px 3px 3px 3px lightgray; width:450px; height: 100px; margin-left:40px;">
          <div class="levelInfo">
            <p style="padding-top:10px; margin-left:30px;">사용자 정보 검색</p>
          </div>
          <div class="levelBox" style="display:flex; margin-left: 30px;">
              <div>
                <vs-select
                  label="user-level"
                  v-model="levelValue">
                  <vs-select-item
                    v-for="(item , index) in UserLevelList"
                    :is-selected.sync="item.isSelected"
                    :key="index"
                    :value="item.value"
                    :text="item.isSelected?item.text:item.text"/>
                </vs-select>
              </div>
                <vs-button @click="searchLevel()" style="margin-top:19px; margin-left:20px; height:40px;">사용자 정보 검색
                </vs-button>
          </div>
        </div>
      <div class="levelText" v-show="levelInfoCard" style="margin-left:40px;">
        <div v-for="(level, index) in userList" :key="index">
          <div class="levelInput" style="display:flex; justify-content:space-around; border-radius: 10px 10px 10px 10px;
          box-shadow: 1px 3px 3px 3px lightgray; width:720px; height: 230px; margin-top:30px;">
            <div class="levelImg" style="display:right">
              <img :src="require(`../../../assets/images/portrait/small/` + level.photo_url)" style="width:170px; height:170px; margin-top:30px">
            </div>
            <div style="display:left">
              <div style="display:flex; margin-top:10px;">
              <vs-input disabled class="mb-base" label="이름" placeholder="user-name" style="width:230px; margin-right:10px;" v-model="level.name" />
              <vs-input disabled class="mb-base" label="이메일" placeholder="user-email" style="width:230px;" v-model="level.email" />
            </div>
            <div style="display:flex; margin-top:-15px;">
                <vs-input disabled class="mb-base" label="계정 생성 날짜" placeholder="create-account" style="width:230px; margin-top:1px; margin-right:10px;" v-model="level.create_time" />
                <vs-input disabled class="mb-base" label="최근 로그인 날짜" placeholder="last-login_time" style="width:230px; margin-top:1px" v-model="level.login_time" />
            </div>
            <div style="display:flex; margin-top:-15px;">
                <vs-input class="mb-base" label="레벨" placeholder="user-level" style="width:100px; margin-top:1px; margin-right:10px;" v-model="level.level" />
                <vs-input class="mb-base" label="별 포인트" placeholder="star-point" style="width:110px; margin-top:1px; margin-right:10px;" v-model="level.star_point" />
                <vs-button @click="saveInfo(index)" style="height:40px; margin-top:20px; margin-left:160px;" type="border" icon-pack="feather" size="small" icon="icon-save">저장
                </vs-button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      levelInfoCard: false,
      levelValue: 2,
      UserLevelList: [
        {text:'레벨 2', value: '2', group: '0', isSelected: false},
        {text:'레벨 5', value: '5', group: '0', isSelected: false},
        {text:'레벨 6', value: '6', group: '0', isSelected: false},
        {text:'레벨 11', value: '11', group: '0', isSelected: false},
      ],
      userList: [],
    }
  },
  computed: {
    levelList(){
      return this.$store.state.searchUser.levelList
    }
  },
  methods: {
    searchLevel() {
      this.$store.dispatch('searchUser/searchLevel', this.levelValue)
      .then(()=>{
        this.userList = JSON.parse(JSON.stringify(this.levelList))
        this.levelInfoCard = true
      })
   },
   saveInfo(val) {
     if(this.userList[val].star_point != this.levelList[val].star_point || this.userList[val].level != this.levelList[val].level){
       this.$store.dispatch('searchUser/updateUserinfo', {'id': this.userList[val].id, 'star_point':this.userList[val].star_point, 'level': this.userList[val].level})
        .then(()=>{
          this.$store.dispatch('searchUser/searchLevel', this.levelValue)
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: '변경사항이 저장되었습니다 :)'
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 해주세요 :('
          })
       })
     }
     else {
       this.$vs.notify({
         color: 'gray',
         title: '유지',
         text: '변동 사항이 없어요 :D'
       })
      }
    }
  }
}
</script>
